var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { combineReducers } from "redux";
import currentUserDetailsReducersMapObject from "@ane/exp-data/lib/userDetails/CurrentUserDetailsReducer";
import getWorkspaceReducersMapObject from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.ducks";
import UserAccessReducersMapObject from "@ane/exp-ux/lib/components/GetUserAccess/UserAccess.reducer";
import selectExperimentationGroupsReducersMapObject from "@ane/exp-ux/lib/components/SelectExperimentationGroup/LoadExperimentationGroups.ducks";
import { W as WPSReducer } from "../workspaceSettingsReducer-0ce19298.js";
import LoadSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/LoadSubscribers.ducks";
import SetSubscribersReducersMapObject from "@ane/exp-ux/lib/components/Subscribers/SetSubscribers.ducks";
import { LoadNotificationSettingListReducer } from "./views/WorkspaceSettingsManagement/components/NotificationSettings/ducks/LoadNotificationSettingList.ducks.js";
import { PutNotificationSettingReducer } from "./views/WorkspaceSettingsManagement/components/NotificationSettings/ducks/PutNotificationSetting.ducks.js";
import { DeleteNotificationSettingReducer } from "./views/WorkspaceSettingsManagement/components/NotificationSettings/ducks/DeleteNotificationSetting.ducks.js";
import LoadSubscribersReducersMapObjectV2 from "@ane/exp-ux/lib/components/Subscribers/LoadSubscribersV2.ducks";
import SetSubscribersReducersMapObjectV2 from "@ane/exp-ux/lib/components/Subscribers/SetSubscribersV2.ducks";
import { mdsApi, authoringApi } from "@ane/exp-data/lib/redux/rtkquery";
const moduleReducer = __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, currentUserDetailsReducersMapObject), getWorkspaceReducersMapObject), UserAccessReducersMapObject), selectExperimentationGroupsReducersMapObject), LoadSubscribersReducersMapObject), SetSubscribersReducersMapObject), LoadSubscribersReducersMapObjectV2), SetSubscribersReducersMapObjectV2), {
  workspaceSettingsModule: WPSReducer,
  notificationSettingModule: combineReducers({
    loadNotificationSettingList: LoadNotificationSettingListReducer,
    putNotificationSetting: PutNotificationSettingReducer,
    deleteNotificationSetting: DeleteNotificationSettingReducer
  }),
  [mdsApi.reducerPath]: mdsApi.reducer,
  [authoringApi.reducerPath]: authoringApi.reducer
});
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
